import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { toCssClass } from 'helpers'
import IndustrialResource from 'components/IndustrialResource/IndustrialResource.jsx'

import {
    ARROW_LAYERS_COUNT,
    UPGRADE_COST_LABEL,
} from './constants.jsx'

import styles from './BuildingCardImage.scss'

export default class BuildingCardImage extends React.Component {
    static propTypes = {
        buildingType: PropTypes.string.isRequired,
        buildingLevel: PropTypes.number.isRequired,
        hasEnoughIndustrialResource: PropTypes.bool.isRequired,
        hasEnoughBuildingLevelSumm: PropTypes.bool,
        upgradeCost: PropTypes.number,
        tooltipId: PropTypes.string,
        isUpgradeAvailable: PropTypes.bool.isRequired,
        showUpgrade: PropTypes.bool.isRequired,
        isMaxCommandCenter: PropTypes.bool,

        onMouseEnter: PropTypes.func.isRequired,
        onMouseLeave: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
    }
    render() {
        const {
            buildingLevel,
            buildingType,
            isUpgradeAvailable,
            showUpgrade,
            upgradeCost,
            hasEnoughIndustrialResource,
            hasEnoughBuildingLevelSumm,
            isMaxCommandCenter,
        } = this.props

        let upgradeLayout
        if (showUpgrade) {
            const arrowLayers = Array.from({ length: ARROW_LAYERS_COUNT }, (item, index) => {
                const layerClass = classNames(styles.arrowLayer, styles[`arrowLayer__${index}`])
                return (
                    <div className={layerClass} key={`arrowLayer_${index}`}></div>
                )
            })

            const notEnoughIndustrialResource = !hasEnoughIndustrialResource && !(hasEnoughBuildingLevelSumm === false)

            const upgradeCostClass = classNames(styles.cost, {
                [styles.cost__notEnough]: notEnoughIndustrialResource,
            })

            let upgradeArrow
            if (hasEnoughIndustrialResource && isUpgradeAvailable) {
                upgradeArrow = <div className={styles.arrow}>{arrowLayers}</div>
            }

            const handleClick = isUpgradeAvailable ? this.props.onClick : null
            const onMouseEnter = isUpgradeAvailable ? this.props.onMouseEnter : null
            const onMouseLeave = isUpgradeAvailable ? this.props.onMouseLeave : null

            const tooltipProps = (this.props.tooltipId) ? {
                'data-tip': true,
                'data-for': this.props.tooltipId,
            } : null

            let innerProps = {
                onClick: handleClick,
                onMouseEnter,
                onMouseLeave,
            }

            let upgradeCostProps


            if (isUpgradeAvailable) {
                innerProps = {
                    ...innerProps,
                    ...tooltipProps,
                }
            } else {
                upgradeCostProps = {
                    ...tooltipProps,
                }
            }


            upgradeLayout = (
                <div className={styles.upgradeLayout} {...innerProps}>
                    <div className={styles.clickArea}></div>
                    <div className={upgradeCostClass} {...upgradeCostProps}>
                        <div className={styles.label}>{UPGRADE_COST_LABEL}</div>
                        <div className={styles.industrialResource}>
                            <IndustrialResource
                                value={upgradeCost}
                                notEnough={notEnoughIndustrialResource}
                            />
                        </div>
                    </div>
                    {upgradeArrow}
                </div>
            )
        }

        const className = classNames(styles.base, {
            [styles.base__upgradeDisabled]: (!isUpgradeAvailable || !showUpgrade),
        })

        const imageClassName = !isMaxCommandCenter ? classNames(
            styles.image,
            styles[`image__${toCssClass(buildingType)}`],
            styles[`image__level-${buildingLevel}`],
        ) : classNames(styles.image, styles['image__max-command-center'])

        return (
            <div className={className}>
                <div className={imageClassName}></div>
                {upgradeLayout}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/BuildingCardImage/BuildingCardImage.jsx